import { createContext, useContext, useEffect, useMemo } from "react";

export const DocumentTitleDetailContext = createContext<
  ((detail: string | null) => void) | null
>(null);

/** The record open on this page (e.g. "#274 101 5th Street"); cleared on leave. */
export const useDocumentTitleDetail = (detail: string | null | undefined) => {
  const setDetail = useContext(DocumentTitleDetailContext);
  const value = useMemo(() => detail?.trim() || null, [detail]);
  useEffect(() => {
    if (!setDetail) return;
    setDetail(value);
    return () => setDetail(null);
  }, [setDetail, value]);
};
